import { FormattedMessage } from 'react-intl';

import { Props as FormattedMessageProps } from 'react-intl/src/components/message';

import { List, ListItem, Tooltip } from '@mui/material';

import clsx from 'clsx';
import styled from 'styled-components';

import { Constants } from '@arrived/common';

import { TextWrapper } from '../../../TextWrapper';
import { OfferingDetailMonetaryValue, OfferingDetailValue } from './OfferingDetailValue';

import { useMediaQueryClasses } from '../../../hooks/useMediaQueryClasses';
import { offeringDetailsListItemPaddingMixin } from './utils';

export interface OfferingTermsDetail {
  text: FormattedMessageProps;
  value?: number;
  isMonetaryValue?: boolean;
  tooltipProps?: FormattedMessageProps;
}

export interface OfferingTermsDetailsListProps {
  className?: string;
  details: OfferingTermsDetail[];
}

const StyledOfferingTermsDetailList = styled(List)`
  &.offering-terms-details-list {
    .offering-terms-details-list-item {
      border-color: ${({ theme }) => theme.palette.neutrals.platinum};
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: ${({ theme }) => theme.spacing(10)};

      ${offeringDetailsListItemPaddingMixin};

      &:last-of-type {
        border: none;
      }
    }

    .offering-terms-detail-text {
      text-decoration: underline;
    }
  }
`;

export const OfferingTermsDetailsList = ({ className, details }: OfferingTermsDetailsListProps) => {
  const mediaQueryClasses = useMediaQueryClasses();

  return (
    <StyledOfferingTermsDetailList className={clsx('offering-terms-details-list', className)}>
      {details.map((detail, index) => {
        const { isMonetaryValue, text, value, tooltipProps } = detail;

        if (value == null) {
          return;
        }

        const label = (
          <TextWrapper
            className="offering-terms-detail-text"
            typographyProps={{ variant: 'body1' }}
            formattedMessageProps={text}
          />
        );

        return (
          <ListItem className={clsx('offering-terms-details-list-item', mediaQueryClasses)} divider key={index}>
            {tooltipProps ? <Tooltip title={<FormattedMessage {...tooltipProps} />}>{label}</Tooltip> : label}
            {isMonetaryValue ? <OfferingDetailMonetaryValue value={value} /> : <OfferingDetailValue value={value} />}
          </ListItem>
        );
      })}
    </StyledOfferingTermsDetailList>
  );
};
